import { createContext } from 'react'

// True for an offer-detail DTO priced under the current carousel filters, including
// flexible filter edits. LE cards must use this price instead of fetching exact-date rates.
// It also selects the marketed-length caption for the DTO's synthetic package.
// Flexible bedbank cards use the explicit pricing slot in ChatHotelCarouselCard.
const CarouselPricingSourceContext = createContext(false)

export default CarouselPricingSourceContext
